import React, { memo } from 'react';
import styled from 'styled-components';

import PinDateIcon from 'assets/v2/PinDateIcon';
import { COLORS } from 'theme';
import { TRIP_TYPE_NAMES } from 'utils/constants';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.oceanGreenDark};
    background: ${COLORS.oceanGreenLight};
    border-color: ${COLORS.oceanGreenDark};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.oceanGreenDark};
    }
  }
`;

function ScheduledTripTypeTag(props) {
  return (
    <StyledTag
      label={TRIP_TYPE_NAMES.SCHEDULED}
      icon={<PinDateIcon />}
      {...props}
    />
  );
}

export default memo(ScheduledTripTypeTag);
